import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";

/**
 * Page views and the signed-in user for GA4 and PostHog. Both are absent
 * unless src/lib/analytics.ts loaded them after consent. The user is the
 * Clerk id, an opaque value; never the email.
 */
export function Analytics() {
  const location = useLocation();
  const { user } = useUser();
  const identified = useRef(false);

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: location.pathname });
    }
    window.posthog?.capture("$pageview");
  }, [location.pathname]);

  useEffect(() => {
    if (!user) {
      if (identified.current) window.posthog?.reset();
      identified.current = false;
      return;
    }
    if (typeof window.gtag === "function") {
      window.gtag("config", import.meta.env.VITE_GA_MEASUREMENT_ID ?? "", {
        user_id: user.id,
        send_page_view: false,
      });
    }
    window.posthog?.identify(user.id);
    identified.current = true;
  }, [user?.id]);

  return null;
}
